import React, { useState } from 'react';
import Picture from '../Picture';
import './LazyYouTube.scss';

const LazyYouTube = ({
    videoId,
    coverImage,
    title,
    width = 300,
    height = 550,
    playerParams = '',
    useNoCookie = false,
}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const embedBaseUrl = useNoCookie ? 'https://www.youtube.com/embed/' : 'https://www.youtube.com/embed/';
    const embedParams = ['autoplay=1', playerParams].filter(Boolean).join('&');

    const handleClick = () => {
        setIsLoaded(true);
        if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({
                event: 'video_play',
                videoId: videoId,
                videoTitle: title || 'YouTube video player',
                videoUrl: `${embedBaseUrl}${videoId}`,
            });
        }
    };

    if (isLoaded) {
        return (
            <div className="lazy-youtube-frame" style={{ aspectRatio: `${width} / ${height}` }}>
                <iframe
                    className="lazy-youtube-embed"
                    width={width}
                    height={height}
                    src={`${embedBaseUrl}${videoId}?${embedParams}`}
                    title={title || "YouTube video player"}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </div>
        );
    }

    return (
        <div className="lazy-youtube-frame" style={{ aspectRatio: `${width} / ${height}` }}>
            <button className="lazy-youtube" onClick={handleClick} aria-label={`Play video: ${title}`}>
                <Picture
                    src={coverImage}
                    alt={title || "Video thumbnail"}
                    className="lazy-youtube-cover"
                />
            </button>
        </div>
    );
};

export default LazyYouTube;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/LazyYouTube/LazyYouTube.jsx